import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { CommonFunction } from '../../common-function';
import { ProjectConstants } from '../../project-constants';
import { MasterGrievanceListService } from './master-grievance-list.service';

const COLS = [
  { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
  { value: "CREATED DATE", lowercaseValue: "createdOn", displayName: "Created Date" },
  { value: "GRIEVANCE ID", lowercaseValue: "pkUsgrid", displayName: "Grievance Id" },
  { value: "GRIEVANCE TYPE", lowercaseValue: "grivType", displayName: "Grievance Type" },
  { value: "SUBJECT", lowercaseValue: "usGriSubject", displayName: "Subject" },
  { value: "STATUS", lowercaseValue: "statusName", displayName: "Status" },
];


export class GrievanceList {
  pkUsgrid: any;
  usGriOwnerId: any
  boardName: any;
  grivType: any;
  usGriSubject: string;
  createdOn: any;
  updatedOn: any;
  statusName: any;
  checkTransferStatus: boolean = false;
  checkSelfAssign: boolean = false

}
@Component({
  selector: 'app-master-grievance-list',
  templateUrl: './master-grievance-list.component.html',
  styleUrls: ['./master-grievance-list.component.scss'],
})
export class MasterGrievanceListComponent implements OnInit {
  displayedCols = COLS;
  allCols = COLS;
  displayedColumns: any[];
  customgrievanceList: GrievanceList[] = [];
  grievanceList: GrievanceList[] = [];
  statusList = []
  selectedReport: any = null
  pageSize: any;
  pageSizeOptions: number[] = [10, 20, 50];
  currentPage: any;
  pageIndex: any;
  dataSource = new MatTableDataSource(this.grievanceList);
  progressSpinnerDialog: any = null;
  filterForm: FormGroup = new FormGroup({});
  grievancenoData = ProjectConstants.grievanceNotAvailable;
  pageEvent: PageEvent;
  totalRows = 0;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(public masterGrievanceService: MasterGrievanceListService,
    public datepipe: DatePipe, public dialog: MatDialog,
    private commonFunction: CommonFunction, private changeDetectorRefs: ChangeDetectorRef,
    public router: Router) { }

  async ngOnInit() {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required])
    });
    var index = localStorage.getItem("PageIndex")
    if (index == null) {
      this.currentPage = Number(localStorage.setItem("PageIndex", "0"))

    } else {
      this.currentPage = Number(localStorage.getItem("PageIndex"))
    }
    var size = localStorage.getItem("PageSize")

    if (size == null) {
      this.pageSize = Number(localStorage.setItem("PageSize", "10"))

    } else {
      this.pageSize = Number(localStorage.getItem("PageSize"))
    }
    this.displayedCols = [
      { value: "GRIEVANCE ID", lowercaseValue: "pkUsgrid", displayName: "Grievance Id" },
      { value: "CREATED DATE", lowercaseValue: "createdOn", displayName: "Created Date" },
      { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
      { value: "GRIEVANCE TYPE", lowercaseValue: "grivType", displayName: "Grievance Type" },
      { value: "SUBJECT", lowercaseValue: "usGriSubject", displayName: "Subject" },
      { value: "STATUS", lowercaseValue: "statusName", displayName: "Status" },
    ];
    this.displayedColumns = this.displayedCols.map((col) => col.value);
    this.dataSource.paginator = this.paginator;

    this.loadMasterStatus();
    this.loadDefaultMaster(this.selectedReport);
  }
  //

  async loadMasterStatus() {
    // this.displayProgressSpinner();
    const response: any = await this.masterGrievanceService.loadStatus();
    // this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.length != 0) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          this.statusList = response
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        this.statusList = []
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }


  async loadDefaultMaster(statusId) {
    if (localStorage.getItem("reload") != null) {
      await this.commonFunction.successToast("GrievanceId : " + localStorage.getItem("reload") + " self assign successfully", false, "")
    }
    this.grievanceList = []
    localStorage.removeItem("reload");
    this.displayProgressSpinner();
    const response1: any = await this.masterGrievanceService.loadMasterGrievanceStatus(this.currentPage, this.pageSize, statusId);
    this.progressSpinnerDialog.close()
    if (response1 != null && !response1.error) {
      if (response1.content.length != 0) {
        const response: any = response1.content
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          for (var i = 0; i < response.length; i++) {
            // var updated_date = response[i].updatedOn
          var updated_date = (response[i].updatedOn!=null && response[i].updatedOn.includes("+"))?response[i].updatedOn.split("+")[0]:response[i].updatedOn

            let updated_on = this.datepipe.transform(updated_date, 'dd/MM/yyyy hh:mm a');
            // var created_date = response[i].createdOn
          var created_date = (response[i].createdOn!=null && response[i].createdOn.includes("+"))?response[i].createdOn.split("+")[0]:response[i].createdOn

            let created_on = this.datepipe.transform(created_date, 'dd/MM/yyyy hh:mm a');
            const customObj = new GrievanceList();
            customObj.pkUsgrid = response[i].pkUsgrid
            customObj.boardName = response[i].boardName
            customObj.grivType = this.text_truncate(response[i].grivType, 30, '....')
            customObj.usGriSubject = this.text_truncate(response[i].usGriSubject, 30, '....');
            customObj.usGriOwnerId = response[i].usGriOwnerId
            customObj.createdOn = created_on
            customObj.updatedOn = updated_on
            customObj.statusName = response[i].statusName
            if (response[i].fkStid == 1 || response[i].fkStid == 2) {
              customObj.checkTransferStatus = true
            }
            if (response[i].usGriOwnerId == null && response[i].fkStid == 1) {
              customObj.checkSelfAssign = true
            }
            this.grievanceList.push(customObj)
          }
          this.dataSource = new MatTableDataSource(this.grievanceList);
          this.changeDetectorRefs.detectChanges();
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = response1.totalElements;
          });
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        this.grievanceList = []
        this.dataSource = new MatTableDataSource(this.grievanceList);
      }
      this.displayedColumns = this.displayedCols.map((col) => col.value);
    } else {
      this.grievanceList = []
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }

  async getServerData(event?: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.currentPage = this.pageIndex
    localStorage.setItem("PageIndex", this.currentPage);
    localStorage.setItem("PageSize", this.pageSize);
    this.loadDefaultMaster(this.selectedReport);
  }


  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  //grievance subject truncate function
  text_truncate(str, length, ending) {
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  }
  //

  //go to assigned grievance forward
  gotoAssignedGrievance(grievanceId: any) {
    this.router.navigate(['secure/assigned-grievance-view/' + grievanceId])
  }
  //

  // go to assigned grievance view
  goToGrievanceView(grievanceId: any) {
    this.router.navigate(['secure/master-grievance-view/' + grievanceId])
  }
  //

  async gotoSelfAssign(grievanceId: any) {
    const data = {
      'complaintId': grievanceId,
    }
    this.displayProgressSpinner();
    const response: any = await this.masterGrievanceService.selfAssign(data);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        localStorage.setItem("reload", grievanceId)
        location.reload()
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
  }

  async applyFilter(search: any) {
    const filterValue = search;
    this.grievanceList=[];
    this.currentPage=0;
   console.log("Filter Called",filterValue);
   this.displayProgressSpinner();
   const response1: any = await this.masterGrievanceService.fetchFilterList(this.currentPage,  this.pageSize,filterValue);
   this.progressSpinnerDialog.close()
   console.log("response1",response1);
   if (response1 != null && !response1.error) {
    console.log("response1",response1.content.length);
     if (response1.content.length != 0) {
       const response: any = response1.content
       console.log("responseS",response[0].statusName);
       if (response[0].status == ProjectConstants.responseStatusSuccess) {
         for (var i = 0; i < response.length; i++) {
           // var updated_date = response[i].updatedOn
         var updated_date = (response[i].updatedOn!=null && response[i].updatedOn.includes("+"))?response[i].updatedOn.split("+")[0]:response[i].updatedOn

           let updated_on = this.datepipe.transform(updated_date, 'dd/MM/yyyy hh:mm a');
           // var created_date = response[i].createdOn
         var created_date = (response[i].createdOn!=null && response[i].createdOn.includes("+"))?response[i].createdOn.split("+")[0]:response[i].createdOn

           let created_on = this.datepipe.transform(created_date, 'dd/MM/yyyy hh:mm a');
           const customObj1 = new GrievanceList();
           customObj1.pkUsgrid = response[i].pkUsgrid
           customObj1.boardName = response[i].boardName
           customObj1.grivType = response[i].grivType//this.text_truncate(response[i].grivType, 30, '....')
           customObj1.usGriSubject = this.text_truncate(response[i].usGriSubject, 30, '....');
       customObj1.usGriOwnerId = response[i].usGriOwnerId
       customObj1.createdOn = created_on
       customObj1.updatedOn = updated_on
           customObj1.statusName = response[i].statusName
           if (response[i].fkStid == 1 || response[i].fkStid == 2) {
            customObj1.checkTransferStatus = true
           }
           if (response[i].usGriOwnerId == null && response[i].fkStid == 1) {
            customObj1.checkSelfAssign = true
           }
           console.log("customObj1",customObj1);
           this.grievanceList.push(customObj1)
         }
         this.dataSource = new MatTableDataSource(this.grievanceList);
         this.changeDetectorRefs.detectChanges();
         setTimeout(() => {
           this.paginator.pageIndex = this.currentPage;
           this.paginator.length = response1.totalElements;
         });
       } else {
          this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
       }
     } else {
       this.grievanceList = []
       this.dataSource = new MatTableDataSource(this.grievanceList);
     }
     this.displayedColumns = this.displayedCols.map((col) => col.value);
   } else {
     this.grievanceList = []
      this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
   }
 //   this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetFilter() {
    location.reload();
  }
}
